import { render, staticRenderFns } from "./PurchaseCard.vue?vue&type=template&id=0336e390"
import script from "./PurchaseCard.vue?vue&type=script&lang=js"
export * from "./PurchaseCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports